import { Box } from "@twilio-paste/core/box";
import { MenuItem, useMenuState } from "@twilio-paste/core/menu";
import { PromptLibrarySuggestionsProps } from "../definitions";

const PromptLibrarySuggestions = ({
  prompt,
  handlePromptSuggestionSelected,
}: PromptLibrarySuggestionsProps) => {
  const menu = useMenuState();

  return (
    <MenuItem
      {...menu}
      onClick={() => handlePromptSuggestionSelected(prompt)}
      onKeyUp={(event) => {
        if (event.key === "Enter") {
          handlePromptSuggestionSelected(prompt);
        }
      }}
    >
      <Box
        as="div"
        fontSize="fontSize30"
        lineHeight="lineHeight20"
        fontWeight="fontWeightNormal"
        marginLeft="space20"
      >
        /{prompt.name}
      </Box>
      <Box
        as="p"
        color="colorTextWeak"
        fontSize="fontSize20"
        lineHeight="lineHeight20"
        fontWeight="fontWeightMedium"
        margin="space0"
      >
        {prompt.template}
      </Box>
    </MenuItem>
  );
};

export default PromptLibrarySuggestions;
